export type CatalogEntry = {
  name: string;
  displayName: string | null;
  imageUrl: string | null;
};

export type Catalog = {
  heroes: Record<string, CatalogEntry>;
  abilities: Record<string, CatalogEntry>;
  items: Record<string, CatalogEntry>;
};

export const EMPTY_CATALOG: Catalog = {
  heroes: {},
  abilities: {},
  items: {},
};
